import { container } from 'tsyringe'
import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators'
import store from '@/app/store/store'
import {
  TrainingMaterialReport,
  Export,
} from '@/domain/entities/TrainingMaterialReport'
import router from '@/router'
import Vue from 'vue'
import { TrainingMaterialReportPresenter } from '@/app/ui/presenters/TrainingMaterialReportPresenter'
import { AuthModule } from './auth'

export interface TrainingMaterialState {
  TrainingMaterialData: TrainingMaterialReport
  exportData: Export
  isLoading: boolean
  paginationParam: Object
}

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: 'TrainingMaterialReport',
})
class TrainingMaterials extends VuexModule implements TrainingMaterialState {
  public isLoading = true
  public isLoadingExport = true
  public TrainingMaterialData = new TrainingMaterialReport(true, '')
  public exportData = new Export(true, '')
  public paginationParam = {
    paging: {
      page: 1,
      limit: 10,
    },
    sort: {
      column: 'TotalViews',
      type: 'desc',
    },
    filter: {
      // salescode: '',
      team: '',
      position: '',
      typeSales: '',
      category: '',
      start: '',
      end: '',
    },
  }
  public paginationParamsExport = {
    paging: {
      page: 1,
      limit: 10,
    },
    sort: {
      column: 'TotalViews',
      type: 'desc',
    },
    search: '',
    filter: {
      // salescode: '',
      team: '',
      position: '',
      typeSales: '',
      category: '',
      start: '',
      end: '',
    },
  }

  @Action
  public async getTrainingMaterialData() {
    this.setLoading(true)
    const presenter = await container.resolve(TrainingMaterialReportPresenter)
    presenter
      .loadTrainingMaterialReport(this.paginationParam)
      .then((res: TrainingMaterialReport) => {
        this.setLoading(false)
        this.setTrainingMaterialData(res)
        //  console.log('Training Material Data', res)
      })
      .catch((error) => {
        console.error('error', error)
        this.setLoading(false)
        if (error.response.status === 401) {
          AuthModule.logOut()
          router.push(`/login`).then(() => {
            Vue.prototype.$notify({
              title: 'Session Expired',
              message: 'Session was expired please login again',
              type: 'error',
              duration: 3000,
            })
          })
        }
      })
  }
  @Action
  public async getExportData() {
    this.setLoading(true)
    this.setLoadingExport(true)
    const presenter = await container.resolve(TrainingMaterialReportPresenter)
    presenter
      .loadExport(this.paginationParam)
      .then((res: Export) => {
        this.setExportData(res)
        //  console.log('export dataaa', res)
      })
      .catch((error) => {
        console.error('error', error)
      })
      .finally(() => {
        this.setLoadingExport(false)
      })
  }

  @Mutation
  private setTrainingMaterialData(TrainingMaterial: TrainingMaterialReport) {
    this.TrainingMaterialData = TrainingMaterial
  }
  @Mutation
  private setExportData(exp: Export) {
    this.exportData = exp
  }
  @Mutation
  private setLoading(isLoading: boolean) {
    this.isLoading = isLoading
  }
  @Mutation
  private setLoadingExport(isLoadingExport: boolean) {
    this.isLoadingExport = isLoadingExport
  }
}

export const TrainingMaterialReportModule = getModule(TrainingMaterials)
